import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { focusStyles } from '../../styled/focus';

export const Fieldset = styled.fieldset`
  width: 100%;
  max-width: 380px;
`;

export const Label = styled.label`
  padding: ${({ theme }) => theme.spacing.tiny};
  cursor: pointer;
`;

export const RadioGroup = styled.div`
  display: flex;
  place-content: center;

  margin-top: ${({ theme }) => theme.spacing.standard};
`;

export const StarSVG = styled(SVG)`
  color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.palette.starRating : 'transparent'};

  stroke: ${({ theme }) => theme.palette.starRating};
  stroke-width: 2px;

  transform: ${({ $isSelected }) =>
    $isSelected ? 'translateY(-4px)' : 'none'};

  scale: ${({ $isSelected }) => ($isSelected ? 1.3 : 1)};

  width: 40px;
  height: 40px;

  transition: scale 0.2s ease-in-out, transform 0.2s ease-in-out,
    filter 0.2s ease-in-out, color 0.2s ease-in-out;
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0px;
  height: 0px;

  &:hover + ${StarSVG} {
    fill: ${({ theme }) => theme.palette.starRating};
  }

  &:focus + ${StarSVG} {
    ${focusStyles}
  }
`;

export const RatingLabelsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RatingLabel = styled.span`
  max-width: 100px;
  text-align: center;
`;
